module.exports = __webpack_public_path__ + "media/images/flags/lu-58d7c92005e24755825c3c5a34e570f6.svg";